module.exports = __webpack_public_path__ + "img/02f9cc3.jpg";